import { Trans } from '@lingui/react';
import { Fragment, isValidElement } from 'react';

export const isTransOrFragmentOrString = (
  element: JSX.Element | string | undefined | null,
): element is JSX.Element | string => {
  if (typeof element === 'string') return true;
  if (isValidElement(element)) {
    return element.type === Trans || element.type === Fragment;
  }
  return false;
};
